import { NOODLE_MEDIA_HOST } from '@/configuration/client';
import { type MediaApiModels } from '@/tsClient/servers/noodleMedia';

const throughServer = (media: Pick<MediaApiModels.Media, 's3OriginId'>): string => {
  const directUrl = new URL(NOODLE_MEDIA_HOST);
  directUrl.pathname = `/file/${media.s3OriginId}`;
  return directUrl.toString();
};

const getMediaUrl = (media: Pick<MediaApiModels.Media, 'url' | 's3OriginId'>): string => {
  if (!media.url) {
    return throughServer(media);
  }
  return media.url;
};

export default getMediaUrl;
